import React from 'react'
import Link from 'gatsby-link'
import { Box, Typography } from '@mui/material'

import { PortableText } from './PortableText'

import { rudderslabTrackOnClick } from '~/utils/common'

export type CenteredContentWithButtonProps = {
  title: string
  content: object
  button: {
    _key: string
    btnexternallink: boolean
    btnhiglight: boolean
    btntext: string
    btnlink: string
  }
}

export const CenteredContentWithButton = (
  props: CenteredContentWithButtonProps
) => (
  <Box
    sx={{
      px: 3.5,
      py: { xs: 5, laptop: 10 },
      color: 'text.primary',
      position: 'relative'
    }}>
    <Box
      sx={{
        width: '100%',
        maxWidth: 1024,
        mx: 'auto',
        textAlign: 'center'
      }}>
      <Typography variant='h2' sx={{ mb: 3 }}>
        {props.title}
      </Typography>

      <PortableText
        blocks={props.content}
        trackSectionHeader={props.title}
        sx={{ mt: 2 }}
      />

      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          mt: 3.5
        }}>
        {props.button.btnexternallink === true && (
          <Box
            component={props?.button?.btnexternallink ? 'a' : Link}
            onClick={e => rudderslabTrackOnClick('button', props.title, e)}
            href={props.button.btnlink}
            to={props.button.btnlink}
            key={props.button._key}
            sx={{
              mr: { xs: 2 },
              mb: { xs: 3, tablet: 0 },
              color: 'primary.light',
              pb: 1.5,
              pt: 2,
              background: props.button.btnhiglight
                ? 'linear-gradient(135.55deg,#3e35d1 6.09%,#86f8e0 116.03%)'
                : 'transparent',
              fontSize: 14,
              px: { xs: 6, mobile: 5, tablet: 4 },
              textAlign: 'center',
              fontWeight: 700,
              border: `1px solid ${
                props.button.btnhiglight ? 'text.secondary' : 'primary.light'
              }`,
              justifyContent: 'center',
              alignItems: 'center',
              textDecoration: 'none',
              borderRadius: 2,
              display: 'inline-block',
              height: 53,
              width: { xs: 190, desktop: 218 },
              '&:hover': {
                color: props.button.btnhiglight
                  ? 'background.default'
                  : 'text.primary',
                background:
                  'linear-gradient(135.55deg,#3e35d1 6.09%,#86f8e0 116.03%)',
                boxShadow: 'inset 0 4px 4px #00000040'
              }
            }}>
            {props.button.btntext}
          </Box>
        )}
      </Box>
    </Box>
  </Box>
)
